import http from './http.service';

class CompanyService {
    constructor() {
        this.$http = http;
        this.baseUrl = "/api/company";
    }

    getInputModelById(id) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http.get(`${this.baseUrl}/${id}`);
    }

    update(model) {
        if (!model) {
            throw new Error('Model is required');
        }

        return this.$http.put(`${this.baseUrl}/`, model);
    }
}

export default new CompanyService();
